import AppContext from "@/AppContext";
import Layout from "@/components/elements/Layout";
import ContentPreferenceItemRegister from "@/components/items/ContentPreferenceItemRegister";
import Spinner from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import useAuth from "@/hooks/auth";
import { useContentPreferences } from "@/hooks/content_preferences";
import { Notebook, User } from "@phosphor-icons/react";
import { useRouter } from "next/router";
import { useContext } from "react";
import toast from "react-hot-toast";

export default function ContentPreferences() {
  const router = useRouter();
  //   const { user } = useAuth({ middleware: "auth" });
  const { user } = useAuth();
  const context = useContext(AppContext);
  const {
    preferences,
    toggleUserPreference,
    updatePreferences,
    isUpdating,
    selectAll,
  } = useContentPreferences();

  const finishOnboarding = () => {
    if (router.query.redirect_to) {
      router.push(router.query.redirect_to);
      return;
    }
    location.href = "/";
  };

  const savePreferences = async (evt) => {
    evt.preventDefault();

    if (preferences.length === 0) {
      finishOnboarding();
      return;
    }

    try {
      await updatePreferences();
      toast.success("Content preferences saved!");
      finishOnboarding();
    } catch (error) {
      toast.error("Couldn't save your content preferences — please try again.");
    }
  };

  const renderContentTypeList = () =>
    context.state.contentTypes.map((contentType) => (
      <ContentPreferenceItemRegister
        key={`content-preference-${contentType.uuid}`}
        name={contentType.name}
        uuid={contentType.uuid}
        selected={preferences.includes(contentType.uuid)}
        onChange={() => toggleUserPreference(contentType.uuid)}
      />
    ));

  return (
    <div className='min-h-screen pb-8 bg-gradient-to-b from-white/10 to-background lg:pb-16'>
      <div className='max-w-2xl px-4 pt-6 mx-auto'>
        <div className='inline-flex border divide-x rounded-lg divide-white/10 bg-white/10 border-white/10'>
          <div className='flex items-center p-3 text-left gap-x-2'>
            <span className='inline-flex items-center justify-center w-8 h-8 rounded-sm'>
              <User className='text-lg' weight='bold' />
            </span>
            {/* <div className='flex flex-col'>
                <span className='text-[10px] font-medium leading-none text-transparent bg-clip-text bg-gradient-to-tr from-yellow-1 to-red-1'>
                  Step 1/3
                </span>
                <p className='mt-1.5 text-sm font-medium leading-none text-white'>
                  Profile Information
                </p>
              </div> */}
          </div>
          <div className='flex items-center p-3 text-left gap-x-2'>
            <span className='inline-flex items-center justify-center w-8 h-8 rounded-sm'>
              <User className='text-lg' weight='bold' />
            </span>
            {/* <div className='flex flex-col'>
                <span className='text-[10px] font-medium leading-none text-transparent bg-clip-text bg-gradient-to-tr from-yellow-1 to-red-1'>
                  Step 2/3
                </span>
                <p className='mt-1.5 text-sm font-medium leading-none text-white'>
                  Topic Preferences
                </p>
              </div> */}
          </div>
          <div className='flex items-center p-3 text-left gap-x-2'>
            <span className='inline-flex items-center justify-center w-8 h-8 bg-white rounded-sm text-background'>
              <Notebook className='text-lg' weight='bold' />
            </span>
            <div className='flex flex-col'>
              <span className='text-[10px] font-medium leading-none text-transparent bg-clip-text bg-gradient-to-tr from-yellow-1 to-red-1'>
                Step 3/3
              </span>
              <p className='mt-1.5 text-sm font-medium leading-none text-white'>
                Content Preferences
              </p>
            </div>
          </div>
        </div>
        <div className='mt-12 lg:mt-20'>
          <p className='mb-2 text-4xl font-bold leading-tight text-white font-display md:text-6xl'>
            Select Content Preferences
          </p>
          <p className='mt-3 text-white text-opacity-80'>
            We know everyone likes to consume their data in different ways.
            Video, Infographics, Articles, or Deep-dive insightful special
            reports you can flip through from start to finish. Tell us how best
            you like your data by selecting content type available, you can
            select more than one
          </p>

          <form onSubmit={savePreferences} className='mt-8'>
            <Button
              type='button'
              variant='outline'
              className='bg-white/5'
              onClick={() => selectAll(context.state.contentTypes)}
            >
              Select All
            </Button>

            <div className='flex flex-wrap gap-1 pt-4 mt-4 mb-6 border-t border-white/10'>
              {renderContentTypeList()}
            </div>

            <Button
              type='submit'
              size='lg'
              className='text-base text-white bg-gradient-to-tr from-yellow-1 to-red-1'
            >
              {isUpdating && <Spinner />}
              {isUpdating ? "Updating..." : "Finalize Data"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
